import { render } from "./PracticeQuestion.vue?vue&type=template&id=e777b818&scoped=true"
import script from "./PracticeQuestion.vue?vue&type=script&lang=js"
export * from "./PracticeQuestion.vue?vue&type=script&lang=js"

import "./PracticeQuestion.vue?vue&type=style&index=0&id=e777b818&scoped=true&lang=css"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e777b818"]])

export default __exports__